import React, { Fragment, useState } from 'react'
import {
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  List,
  Tooltip,
  Typography,
  
  Link,
  ListItemText,
  CircularProgress,
  ListItem,
  ListItemAvatar,
  Avatar
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { apiCall, ApiConfig } from '../../../config/api'
import { SnackBar } from '../../SnackBar/Snackbar'
import { ApiResponse } from '../../../models/ApiResponse'
import axios from 'axios'

import HelpIcon from '@mui/icons-material/Help'
import { templateWorkOrderMassiveProcess } from '../../../const/templatesFileName'
import { SelectWarehouse } from '../../Warehouse'
import { Warehouse } from '../../../interfaces'
import Info from '@mui/icons-material/Info'

/*
Copyright 2022-07-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Agrega selección warehouse al crear WorkOrder por archivo.
*/

const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 15,
    borderRadius: 5
  },
  colorPrimary: {
    backgroundColor: '#EEEEEE'
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff'
  }
}))(LinearProgress)

class SnackBarStatus {
  isOpen: boolean = false
  message: string = ''
  status: string = ''
}

interface UploadOrderFileProps {
  warehouses: Warehouse[] | undefined
}

export const UploadOrderFile: React.FC<UploadOrderFileProps> = ({
  warehouses = []
}) => {
  const maxFileSize = 2097152
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [selectedFiles, setSelectedFiles] = useState<any[] | undefined>(
    undefined
  )
  const [currentFile, setCurrentFile] = useState<any | undefined>(undefined)
  const [progress, setProgress] = useState<number>(0)
  const [snackBarStatus, setSnackBarStatus] = useState<SnackBarStatus>(
    new SnackBarStatus()
  )
  const [disabledLink, setDisabledLink] = useState<boolean>(false)

  const [selectedWarehouse, setSelectedWarehouse] = useState<number>(0)

  const notify = (message: string, status: string) => {
    const newStatus: SnackBarStatus = {
      isOpen: true,
      message: message,
      status: status
    }
    setSnackBarStatus(newStatus)
  }

  const handleSnackbar = (isOpen: boolean) => {
    setSnackBarStatus({ ...snackBarStatus, isOpen: isOpen })
  }

  const handleSelectFile = (event: any) => {
    setSelectedFiles(event.target.files)
    setProgress(0)
    setSnackBarStatus(new SnackBarStatus())
  }

  const sizeLabel = (size: number): string => {
    let label = ''
    if (size / 1024 / 1024 > 1) label = (size / 1024 / 1024).toFixed(2) + ' MB'
    else if (size / 1024 > 1) label = (size / 1024).toFixed(0) + ' KB'
    else label = size.toFixed(2) + ' Bytes'
    return label
  }

  // const fileSizeText = (): string => {
  //   if (!selectedFiles || selectedFiles.length === 0) return ''
  //   const label = sizeLabel(selectedFiles[0].size)
  //   return label
  // }

  const validateFile = (files: any[] | undefined): string => {
    if (!files || files.length === 0) {
      return 'Ningún archivo seleccionado'
    }

    const selectedFile = files[0]

    if (selectedFile.size > maxFileSize) {
      const maxLabel = sizeLabel(maxFileSize)
      return `El archivo seleccionado supera el tamaño máximo: ${maxLabel}`
    }

    if (selectedFile.name.toLowerCase().indexOf('.xls') < 0) {
      return `El archivo seleccionado no es de tipo Excel (.xls)`
    }

    return ''
  }

  const callUpload = (file: any, onUploadProgress: (event: any) => void) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('warehouseId', `${selectedWarehouse}`)

    const axiosInstance = axios.create({
      baseURL: ApiConfig.ProcessApi,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return axiosInstance.post(`/WorkOrderUploadFile`, formData, {
      onUploadProgress
    })
  }

  const handleUpload = () => {
    const validateError = validateFile(selectedFiles)
    if (validateError !== '') {
      setCurrentFile(undefined)
      notify(validateError, 'error')
      return
    }

    if (!selectedFiles) return

    const selectedFile = selectedFiles[0]
    setProgress(0)
    setCurrentFile(selectedFile)
    setIsUploading(true)

    callUpload(selectedFile, (event) => {
      setProgress(Math.round((100 * event.loaded) / event.total))
    })
      .then((response) => {
        const apiResponse = response.data as ApiResponse
        setIsUploading(false)
        if (apiResponse.success) {
          notify('El archivo ha sido cargado para su procesamiento', 'success')
        } else {
          notify(
            `Error en carga de archivo: ${
              apiResponse.message || 'falla en el servicio.'
            }`,
            'error'
          )
        }
        setCurrentFile(undefined)
        setSelectedFiles(undefined)
        setProgress(0)
      })
      .catch((error) => {
        setIsUploading(false)
        setProgress(0)
        notify(
          `Error en carga de archivo: ${
            error.response?.data?.message || 'falla en el servicio.'
          }`,
          'error'
        )
        setCurrentFile(undefined)
        setSelectedFiles(undefined)
        setProgress(0)
      })
  }

  const handleDownloadTemplate = () => {
    setDisabledLink(true)
    setTimeout(() => {
      apiCall(
        'GET',
        `${ApiConfig.ProcessApi}/GetTemplateFile/${templateWorkOrderMassiveProcess}`,
        {
          responseType: 'blob'
        }
      )
        .then((response: any) => {
          if (response.status === 200 && response.data !== null) {
            const raw = window.atob(response.data.file)
            const uInt8Array = new Uint8Array(raw.length)
            for (let i = 0; i < raw.length; ++i) {
              uInt8Array[i] = raw.charCodeAt(i)
            }
            const link = document.createElement('a')
            const blob = new Blob([uInt8Array], {
              type: response.data.mimeType
            })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', response.data.name)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch((message: any) => {
          console.log('message: ', message)
        })
      setDisabledLink(false)
    }, 1500)
  }

  React.useEffect(() => {
    if (warehouses?.length === 1) {
      setSelectedWarehouse(warehouses[0].id)
    }
  }, [warehouses])

  return (
    <Fragment>
      <Grid container spacing={4} direction='column' alignItems='center'>
        <Typography variant='h4' component='h4'>
          Cargar filtro externo de pedidos
        </Typography>

        <Grid item xs={12} style={{ padding: '0px' }}>
          <List style={{ width: '100%' }}>
            <ListItem alignItems='flex-start'>
              <ListItemAvatar>
                <Avatar>
                  <Info />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant='h6' component='h6' gutterBottom>
                    El archivo Excel debe contener una columna con el ID de
                    pedido (ID Externo) que permite crear ordenes de trabajo.
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography component='ol' style={{ listStyle: 'square' }}>
                      <Typography
                        variant='subtitle1'
                        component='li'
                        gutterBottom
                      >
                        Puede descargar una <b>plantilla</b> desde el link que
                        se encuentra disponible a continuación.
                        <br />
                        {disabledLink ? (
                          <Fragment>
                            <Link
                              style={{
                                cursor: 'pointer',
                                pointerEvents: 'none'
                              }}
                              onClick={handleDownloadTemplate}
                            >
                              Descargando Plantilla...
                            </Link>{' '}
                            <CircularProgress size='0.9rem' />
                          </Fragment>
                        ) : (
                          <Link
                            style={{ cursor: 'pointer' }}
                            onClick={handleDownloadTemplate}
                          >
                            Descargar Plantilla
                          </Link>
                        )}
                      </Typography>
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        justifyContent='center'
        alignItems='center'
        alignContent='center'
        style={{ textAlign: 'center' }}
      >
        <SelectWarehouse
          warehouses={warehouses}
          onChange={setSelectedWarehouse}
          selectedWarehouse={selectedWarehouse}
        />
      </Grid>

      <Box className='mb25' display='flex' alignItems='center'>
        <Grid
          container
          spacing={4}
          direction='row'
          alignItems='center'
          justifyContent='center'
          style={{ justifyContent: 'center' }}
        >
          <Grid item xs={3} style={{ textAlign: 'right' }}>
            <label htmlFor='btn-upload'>
              <input
                id='btn-upload'
                name='btn-upload'
                style={{ display: 'none' }}
                type='file'
                onChange={handleSelectFile}
                accept='.xls,.xlsx'
              />
              <Tooltip
                title='Seleccionar el archivo Excel a cargar'
                placement='top-end'
              >
                <Button
                  className='btn-choose'
                  variant='outlined'
                  component='span'
                >
                  Seleccionar Archivo
                </Button>
              </Tooltip>
            </label>
          </Grid>

          <Grid item xs={5}>
            <div className='file-name'>
              {selectedFiles && selectedFiles.length > 0
                ? selectedFiles[0].name
                : null}
            </div>
          </Grid>

          <Grid item xs={1}>
            <Tooltip
              title='Enviar el archivo seleccionado al servidor para su procesamiento'
              placement='top-end'
            >
              <Button
                className='btn-upload'
                color='primary'
                variant='contained'
                component='span'
                disabled={
                  selectedWarehouse === 0 || !selectedFiles || isUploading
                }
                onClick={handleUpload}
              >
                Cargar
              </Button>
            </Tooltip>
          </Grid>

          <Grid
            item
            xs={1}
            alignContent='center'
            style={{ textIndent: '15px' }}
          >
            <Tooltip
              title='Oprima el botón SELECCIONAR para abrir el archivo a cargar y luego el botón CARGAR para enviar el archivo al servidor para su procesamiento'
              placement='top-end'
            >
              <IconButton>
                <HelpIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>

      <div
        style={{
          margin: '10px',
          visibility: currentFile ? 'visible' : 'hidden'
        }}
      >
        <BorderLinearProgress variant='determinate' value={progress} />

        <Box minWidth={35}>
          <Typography
            variant='body1'
            color='textSecondary'
            style={{ textAlign: 'end' }}
          >{`${progress}%`}</Typography>
        </Box>
      </div>

      <SnackBar
        open={snackBarStatus.isOpen}
        setOpen={handleSnackbar}
        message={snackBarStatus.message}
        status={snackBarStatus.status}
      ></SnackBar>
    </Fragment>
  )
}
